import { QueryReturnValue } from '@reduxjs/toolkit/query';

function convertPromiseToQueryReturnValue<T>(
  promise: Promise<T>
): Promise<QueryReturnValue<T, unknown, {}>> {
  return promise
    .then(
      (data) =>
        ({ data, meta: {}, error: undefined } as QueryReturnValue<
          T,
          unknown,
          {}
        >)
    )
    .catch(
      (error) =>
        ({
          error: error?.message,
          data: undefined,
          meta: {},
        } as QueryReturnValue<T, unknown, {}>)
    );
}

export default convertPromiseToQueryReturnValue;
